import translation from 'translation';
import { commaSeperator, sentimentColors } from 'utils';

const { t } = translation;

const PLATFORM_API_PATH = {
  twitter: '/twitter/posts',
  virasty: '/virasty/posts',
  telegram: '/telegram/posts',
  news: '/news/posts',
  nativePlatforms: '/iranian-platforms/posts',
  eitaa: '/iranian-platforms/posts',
  bale: '/iranian-platforms/posts',
  rubika: '/iranian-platforms/posts',
  linkedin: '/linkedin/posts',
  instagram: '/instagram/posts',
  instagramComment: '/instagram/comments',
  instagramCommentByPost: '/instagram/comments',
};

/**
 * The newspaper platform has no NSS endpoint, so it resolves to null and the
 * whole section is skipped for it instead of firing a request that 404s.
 */
export const getNssApiPath = (platform) => PLATFORM_API_PATH[platform] ?? null;

export const hasNssSupport = (platform) => Boolean(getNssApiPath(platform));

/**
 * The generic `Gauge` component is configured, not owned, by NSS — every page
 * that shows a net sentiment score gauge (statistics, source profile, brand
 * baan) shares this same range/palette/formatting rather than each redefining
 * it.
 */
export const NSS_GAUGE_RANGE = { min: -100, max: 100 };

export const getNssGaugeColors = () => [
  sentimentColors.gaugeStart,
  sentimentColors.gaugeMiddle,
  sentimentColors.gaugeEnd,
];

const withSign = (score) => `${score > 0 ? '+' : ''}${commaSeperator(score)}`;

export const formatNssGaugeValue = (score) =>
  t('statistics:netSentimentScore.value', { value: withSign(score) });

/**
 * The compact signed "+12" form a gauge's hover-tooltip rows use, as opposed to
 * the phrase `formatNssGaugeValue` builds for the dial's own big number. An NSS
 * is a score, not a percentage, so it carries no "%" sign.
 */
export const formatNssScore = withSign;

export const getNssGaugeLabels = () => ({
  min: t('statistics:netSentimentScore.minLabel'),
  max: t('statistics:netSentimentScore.maxLabel'),
  mid: t('statistics:netSentimentScore.zeroLabel'),
});
